import * as React from 'react';
import { Box } from '@mui/material';
import OrgSidebar from './OrgSidebar';
import OrgMainContent from './OrgMainContent';

export interface OrgsProps {
  orgId?: string;
}

const Orgs: React.FC<OrgsProps> = () => {
  return (
    <Box sx={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}>
      <OrgSidebar />
      <OrgMainContent />
    </Box>
  );
};

export default Orgs;
